import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import { SelectInput } from '../Inputs/Inputs.jsx'
import AppDispatcher from '../../../dispatchers/AppDispatcher'

const Debounce = ({ device }) => {
  const [debounce, setDebounce] = useState(device.physical.debounce)

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        debounce,
      },
    })
  }, [debounce])

  useEffect(() => {
    appDispatch()
  }, [debounce, appDispatch])

  const handleChange = useCallback((field, value, callback) => {
    let updateValue = false
    updateValue = value === 'true' || value === true
    setDebounce(updateValue)
  }, [appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const unit = ''

  const select = [
    {
      value: false,
      name: 'No',
    },
    {
      value: true,
      name: 'Yes',
    },
  ]

  let currentSetting = 'No'
  if (device.physical.debounce) {
    currentSetting = 'Yes'
  }

  return (
    <div>
      <section>
        <h3>
          Current Setting
        </h3>
        <ul>
          <li>
            <span>Debounce Values</span>
            <span>
              {currentSetting}
              {unit}
            </span>
          </li>
        </ul>
      </section>
      <section>
        <h3>
          New Setting
        </h3>
        <ul>
          <li>
            <span>Debounce Values</span>
            <span>
              <SelectInput
                value={debounce}
                childChange={childChange}
                field='debounce'
                options={select}
              />
              {unit}
            </span>
          </li>
        </ul>
      </section>
    </div>
  )
}

Debounce.propTypes = {
  device: PropTypes.object.isRequired,
}

export default Debounce
